"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-twelve/sections/footerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode, MouseEventHandler } from "react";

type FooterSectionSupportsItem = {
    key: Key | null | undefined;
    /** Detected variants: "isax isax-call" | "isax isax-sms" */
    className: string;
    /** Detected variants: "+1 24565 89856" | "contact@example.com" */
    link0Text: ReactNode;
    /** Detected variants: "callto:" | "mailto:" */
    href: string;
    /** Detected variants: "support-item" */
    divClassName?: string;
    /** Detected variants: "suppor-icon" */
    div0ClassName?: string;
};

type FooterSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/pay-1.svg" | "/Templates/Doccure/img/icons/pay-2.svg" | "/Templates/Doccure/img/icons/pay-3.svg" | "/Templates/Doccure/img/icons/pay-4.svg" */
    src: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid pay-1" */
    className?: string;
};

type FooterSectionFooterSocialMenusItem = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Privacy Policy" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.privacyPolicy" */
    href: string;
    /** Detected variants: "Contact Us" | "Terms & Conditions" */
    link0Link0Text: ReactNode;
    /** Detected variants: "all_routes.contactUs" | "all_routes.termsAndCondition" */
    link0Href: string;
    /** Detected variants: "Hospitals" */
    link0Link0Text2?: ReactNode;
    /** Detected variants: "all_routes.hospitals" */
    link0Href2?: string;
    /** Detected variants: "Specialities" */
    link0Link0Text3?: ReactNode;
    /** Detected variants: "all_routes.speciality" */
    link0Href3?: string;
    /** Detected variants: "Clinics" */
    link0Link0Text4?: ReactNode;
    /** Detected variants: "all_routes.clinics" */
    link0Href4?: string;
    /** Detected variants: "footer-social-menu" */
    className?: string;
};

type FooterSectionUls3Item = {
    key: Key | null | undefined;
    /** Detected variants: "Privacy Policy" | "Terms & Conditions" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.privacyPolicy" | "all_routes.termsAndCondition" */
    href: string;
};

type FooterSectionUlsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-brands fa-facebook" | "fa-brands fa-x-twitter" | "fa-brands fa-instagram" | "fa-brands fa-linkedin" */
    className: string;
    /** Detected variants: "#" */
    href?: string;
};

type FooterSectionUls2Item = {
    key: Key | null | undefined;
    /** Detected variants: "About" | "Contact Us" | "Hospitals" | "Specialities" | "Clinics" */
    link0Text: ReactNode;
    /** Detected variants: "all_routes.aboutUs" | "all_routes.contactUs" | "all_routes.hospitals" | "all_routes.speciality" | "all_routes.clinics" */
    href: string;
};
export type HomeTwelveFooterSectionGeneratedProps = {
    scrollToTop?: MouseEventHandler<HTMLAnchorElement>;
    divLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionSupportsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerDiv0Div0Div0ClassName?: string;
    /** Default: "Doccure" */
    footerDiv0Div0Div0Div0Div0Div0H20H2Text?: ReactNode;
    footerDiv0Div0Div0Div0Div0Div0H20H2Visible?: boolean;
    footerDiv0Div0Div0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Supporting you to keep your child healthy with easy access to high-quality paediatric care." */
    footerDiv0Div0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "183 Marina Avenue, Miami, Florida State, USA" */
    footerDiv0Div0Div0Div1Div0Div2P0PText?: ReactNode;
    /** Default: "Services" */
    footerDiv0Div0Div0Div1Div0H40H4Text?: ReactNode;
    footerDiv0Div0Div0Div1Div0H40H4Visible?: boolean;
    footerDiv0Div0Div0Div1Div0H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div1Div0H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "shape" */
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-shape-img.png" */
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerDiv0Div0Div0Div2Div0Div0Div0Form0FormVisible?: boolean;
    footerDiv0Div0Div0Div2Div0Div0Div0Form0FormRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Div0Div0Div0Form0FormProps?: Partial<ComponentProps<"form">>;
    footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonVisible?: boolean;
    footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: "Enter Email Address" */
    footerDiv0Div0Div0Div2Div0Div0Div0Form0Input0InputPlaceholder?: string;
    /** Default: "Subscribe to get new updates" */
    footerDiv0Div0Div0Div2Div0H40H4Text?: ReactNode;
    footerDiv0Div0Div0Div2Div0H40H4Visible?: boolean;
    footerDiv0Div0Div0Div2Div0H40H4Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Div0H40H4Props?: Partial<ComponentProps<"h4">>;
    /** Default: "Join our Community" */
    footerDiv0Div0Div0Div2Div0H50H5Text?: ReactNode;
    footerDiv0Div0Div0Div2Div0H50H5Visible?: boolean;
    footerDiv0Div0Div0Div2Div0H50H5Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Div0H50H5Props?: Partial<ComponentProps<"h5">>;
    /** Default: "shape" */
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-shape-img.png" */
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageSrc?: string;
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageVisible?: boolean;
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Get the latest news, offers, and insights delivered straight to your inbox." */
    footerDiv0Div0Div0Div2Div0P0PText?: ReactNode;
    /** Default: "Copyright © 2026 Doccure. All Rights Reserved" */
    footerDiv1Div0Div0Div0P0PText?: ReactNode;
    /** Default: "#" */
    footerDiv1Link0LinkHref?: string;
    footerDiv1Link0LinkVisible?: boolean;
    footerDiv1Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerDiv1Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "footer" */
    footerImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-lab-shadow.png" */
    footerImageWithBasePath0ImageSrc?: string;
    footerImageWithBasePath0ImageVisible?: boolean;
    footerImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "footer" */
    footerImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/footer-lab-img.png" */
    footerImageWithBasePath1ImageSrc?: string;
    footerImageWithBasePath1ImageVisible?: boolean;
    footerImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    footerSectionUls2LiLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
    liLink0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    linkImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSectionDivsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerSectionSupports: FooterSectionSupportsItem[];
    footerSectionDivs: FooterSectionDivsItem[];
    footerSectionFooterSocialMenus: FooterSectionFooterSocialMenusItem[];
    footerSectionUls3: FooterSectionUls3Item[];
    footerSectionUls: FooterSectionUlsItem[];
    footerSectionUls2: FooterSectionUls2Item[];
    footerSectionSupportsItemWrapper?: (item: FooterSectionSupportsItem, content: ReactNode) => ReactNode;
    footerSectionSupportsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionSupportsLinkVisible?: boolean;
    footerSectionSupportsLinkRenderer?: (item: FooterSectionSupportsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionSupportsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionSupportsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionDivsItemWrapper?: (item: FooterSectionDivsItem, content: ReactNode) => ReactNode;
    footerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkVisible?: boolean;
    footerSectionDivsLinkRenderer?: (item: FooterSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionDivsImageVisible?: boolean;
    footerSectionDivsImageRenderer?: (item: FooterSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionDivsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: FooterSectionDivsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    footerSectionFooterSocialMenusItemWrapper?: (item: FooterSectionFooterSocialMenusItem, content: ReactNode) => ReactNode;
    footerSectionFooterSocialMenusRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls3ItemWrapper?: (item: FooterSectionUls3Item, content: ReactNode) => ReactNode;
    footerSectionUls3Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsItemWrapper?: (item: FooterSectionUlsItem, content: ReactNode) => ReactNode;
    footerSectionUlsRenderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkVisible?: boolean;
    footerSectionUlsLinkRenderer?: (item: FooterSectionUlsItem, defaultNode: ReactNode) => ReactNode;
    footerSectionUlsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUlsItem) => Partial<ComponentProps<typeof SmartLink>>);
    footerSectionUls2ItemWrapper?: (item: FooterSectionUls2Item, content: ReactNode) => ReactNode;
    footerSectionUls2Renderer?: (defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkVisible?: boolean;
    footerSectionUls2LinkRenderer?: (item: FooterSectionUls2Item, defaultNode: ReactNode) => ReactNode;
    footerSectionUls2LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: FooterSectionUls2Item) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeTwelveFooterSectionGenerated: FC<HomeTwelveFooterSectionGeneratedProps> = ({
    scrollToTop,
    footerDiv0Div0Div0Div0Div0Div0H20H2Text = "Doccure",
    footerDiv0Div0Div0Div0Div0Div0H20H2Visible,
    footerDiv0Div0Div0Div0Div0Div0H20H2Renderer,
    footerDiv0Div0Div0Div0Div0Div0H20H2Props,
    footerDiv0Div0Div0Div0Div0P0PText = "Supporting you to keep your child healthy with easy access to high-quality paediatric care.",
    footerDiv0Div0Div0Div1Div0Div2P0PText = "183 Marina Avenue, Miami, Florida State, USA",
    footerDiv0Div0Div0Div1Div0H40H4Text = "Services",
    footerDiv0Div0Div0Div1Div0H40H4Visible,
    footerDiv0Div0Div0Div1Div0H40H4Renderer,
    footerDiv0Div0Div0Div1Div0H40H4Props,
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt = "shape",
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-shape-img.png",
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible,
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps,
    footerDiv0Div0Div0Div2Div0Div0Div0Form0Input0InputPlaceholder = "Enter Email Address",
    footerDiv0Div0Div0Div2Div0H40H4Text = "Subscribe to get new updates",
    footerDiv0Div0Div0Div2Div0H40H4Visible,
    footerDiv0Div0Div0Div2Div0H40H4Renderer,
    footerDiv0Div0Div0Div2Div0H40H4Props,
    footerDiv0Div0Div0Div2Div0H50H5Text = "Join our Community",
    footerDiv0Div0Div0Div2Div0H50H5Visible,
    footerDiv0Div0Div0Div2Div0H50H5Renderer,
    footerDiv0Div0Div0Div2Div0H50H5Props,
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageAlt = "shape",
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-shape-img.png",
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageVisible,
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageRenderer,
    footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageProps,
    footerDiv0Div0Div0Div2Div0P0PText = "Get the latest news, offers, and insights delivered straight to your inbox.",
    footerDiv1Div0Div0Div0P0PText = "Copyright © 2026 Doccure. All Rights Reserved",
    footerDiv1Link0LinkHref = "#",
    footerDiv1Link0LinkVisible,
    footerDiv1Link0LinkRenderer,
    footerDiv1Link0LinkProps,
    footerImageWithBasePath0ImageAlt = "footer",
    footerImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/footer-lab-shadow.png",
    footerImageWithBasePath0ImageVisible,
    footerImageWithBasePath0ImageRenderer,
    footerImageWithBasePath0ImageProps,
    footerImageWithBasePath1ImageAlt = "footer",
    footerImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/footer-lab-img.png",
    footerImageWithBasePath1ImageVisible,
    footerImageWithBasePath1ImageRenderer,
    footerImageWithBasePath1ImageProps,
    footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonVisible,
    footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonRenderer,
    footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonProps,
    footerDiv0Div0Div0Div2Div0Div0Div0Form0FormVisible,
    footerDiv0Div0Div0Div2Div0Div0Div0Form0FormRenderer,
    footerDiv0Div0Div0Div2Div0Div0Div0Form0FormProps,
    divLink0LinkProps,
    footerSectionUls2LiLink0LinkProps,
    liLink0LinkProps,
    linkImageWithBasePath0ImageProps,
    linkLinkProps,
    footerDiv0Div0Div0ClassName,
    footerSectionSupports,
    footerSectionDivs,
    footerSectionFooterSocialMenus,
    footerSectionUls3,
    footerSectionUls,
    footerSectionUls2,
    footerSectionSupportsItemWrapper,
    footerSectionSupportsRenderer,
    footerSectionSupportsLinkVisible,
    footerSectionSupportsLinkRenderer,
    footerSectionSupportsLinkProps,
    footerSectionDivsItemWrapper,
    footerSectionDivsRenderer,
    footerSectionDivsLinkVisible,
    footerSectionDivsLinkRenderer,
    footerSectionDivsImageVisible,
    footerSectionDivsImageRenderer,
    footerSectionDivsLinkProps,
    footerSectionDivsImageProps,
    footerSectionFooterSocialMenusItemWrapper,
    footerSectionFooterSocialMenusRenderer,
    footerSectionUls3ItemWrapper,
    footerSectionUls3Renderer,
    footerSectionUlsItemWrapper,
    footerSectionUlsRenderer,
    footerSectionUlsLinkVisible,
    footerSectionUlsLinkRenderer,
    footerSectionUlsLinkProps,
    footerSectionUls2ItemWrapper,
    footerSectionUls2Renderer,
    footerSectionUls2LinkVisible,
    footerSectionUls2LinkRenderer,
    footerSectionUls2LinkProps,
}) => {
    return (
        <footer className="footer-twelve">
            <div className="footer-top">
                <div className="container">
                    <div className={footerDiv0Div0Div0ClassName ?? "row g-4"}>
                        <div className="col-xl-5 col-lg-4 col-md-12">
                            <div className="footer-widget footer-about">
                                <p className="paragraph">
                                    {footerDiv0Div0Div0Div0Div0P0PText}
                                    {" "}
                                </p>
                                <div className="footer-logo">
                                    {renderNode(footerDiv0Div0Div0Div0Div0Div0H20H2Visible, footerDiv0Div0Div0Div0Div0Div0H20H2Renderer, (
                                        <h2 className="text-gradient" {...(footerDiv0Div0Div0Div0Div0Div0H20H2Props ?? {})}>{footerDiv0Div0Div0Div0Div0Div0H20H2Text}</h2>
                                    ))}
                                </div>
                                <ul className="social-icon">
                                    {renderCollectionNode(
                                        footerSectionUls,
                                        (item: FooterSectionUlsItem) => (
                                            <li key={item.key}>
                                                {renderItemNode(footerSectionUlsLinkVisible, footerSectionUlsLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "#"} {...(typeof footerSectionUlsLinkProps === "function" ? footerSectionUlsLinkProps(item) : (footerSectionUlsLinkProps ?? {}))} {...(typeof liLink0LinkProps === "function" ? liLink0LinkProps(item) : (liLink0LinkProps ?? {}))}>
                                                        <i className={item.className} />
                                                    </SmartLink>
                                                ))}
                                            </li>
                                        ),
                                        footerSectionUlsItemWrapper,
                                        footerSectionUlsRenderer
                                    )}
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6">
                            <div className="footer-support">
                                {renderNode(footerDiv0Div0Div0Div1Div0H40H4Visible, footerDiv0Div0Div0Div1Div0H40H4Renderer, (
                                    <h4 className="footer-title" {...(footerDiv0Div0Div0Div1Div0H40H4Props ?? {})}>{footerDiv0Div0Div0Div1Div0H40H4Text}</h4>
                                ))}
                                {renderCollectionNode(
                                    footerSectionSupports,
                                    (item: FooterSectionSupportsItem) => (
                                        <div className={item.divClassName ?? "support-item"} key={item.key}>
                                            <div className={item.div0ClassName ?? "suppor-icon"}>
                                                <i className={item.className} />
                                            </div>
                                            {renderItemNode(footerSectionSupportsLinkVisible, footerSectionSupportsLinkRenderer, item, (
                                                <SmartLink href={item.href} {...(typeof footerSectionSupportsLinkProps === "function" ? footerSectionSupportsLinkProps(item) : (footerSectionSupportsLinkProps ?? {}))} {...(typeof divLink0LinkProps === "function" ? divLink0LinkProps(item) : (divLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                            ))}
                                        </div>
                                    ),
                                    footerSectionSupportsItemWrapper,
                                    footerSectionSupportsRenderer
                                )}
                                {renderNode(footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageVisible, footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageSrc} alt={footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid footer-shape-img" {...(footerDiv0Div0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-6">
                            <div className="footer-support">
                                {renderNode(footerDiv0Div0Div0Div2Div0H40H4Visible, footerDiv0Div0Div0Div2Div0H40H4Renderer, (
                                    <h4 className="footer-title" {...(footerDiv0Div0Div0Div2Div0H40H4Props ?? {})}>{footerDiv0Div0Div0Div2Div0H40H4Text}</h4>
                                ))}
                                <div className="footer-subscribe">
                                    <div className="subscribe-input">
                                        {renderNode(footerDiv0Div0Div0Div2Div0Div0Div0Form0FormVisible, footerDiv0Div0Div0Div2Div0Div0Div0Form0FormRenderer, (
                                            <form action="#" {...(footerDiv0Div0Div0Div2Div0Div0Div0Form0FormProps ?? {})}>
                                                <input type="email" className="form-control" placeholder={footerDiv0Div0Div0Div2Div0Div0Div0Form0Input0InputPlaceholder} />
                                                {renderNode(footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonVisible, footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonRenderer, (
                                                    <button type="submit" className="btn-icon btn btn-secondary" {...(footerDiv0Div0Div0Div2Div0Div0Div0Form0Button0ButtonProps ?? {})}>
                                                        <i className="isax isax-arrow-right-1" />
                                                    </button>
                                                ))}
                                            </form>
                                        ))}
                                    </div>
                                </div>
                                {renderNode(footerDiv0Div0Div0Div2Div0H50H5Visible, footerDiv0Div0Div0Div2Div0H50H5Renderer, (
                                    <h5 className="sub-title" {...(footerDiv0Div0Div0Div2Div0H50H5Props ?? {})}>{footerDiv0Div0Div0Div2Div0H50H5Text}</h5>
                                ))}
                                <p>{footerDiv0Div0Div0Div2Div0P0PText}</p>
                                {renderNode(footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageVisible, footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageSrc} alt={footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageAlt} className="img-fluid footer-shape-img-1" {...(footerDiv0Div0Div0Div2Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="footer-menus footer-about">
                        {renderCollectionNode(
                            footerSectionFooterSocialMenus,
                            (item: FooterSectionFooterSocialMenusItem) => (
                                <ul className={item.className ?? "footer-social-menu"} key={item.key}>
                                    {renderCollectionNode(
                                        footerSectionUls2,
                                        (item: FooterSectionUls2Item) => (
                                            <li key={item.key}>
                                                {renderItemNode(footerSectionUls2LinkVisible, footerSectionUls2LinkRenderer, item, (
                                                    <SmartLink href={item.href} {...(typeof footerSectionUls2LinkProps === "function" ? footerSectionUls2LinkProps(item) : (footerSectionUls2LinkProps ?? {}))} {...(typeof footerSectionUls2LiLink0LinkProps === "function" ? footerSectionUls2LiLink0LinkProps(item) : (footerSectionUls2LiLink0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </li>
                                        ),
                                        footerSectionUls2ItemWrapper,
                                        footerSectionUls2Renderer
                                    )}
                                </ul>
                            ),
                            footerSectionFooterSocialMenusItemWrapper,
                            footerSectionFooterSocialMenusRenderer
                        )}
                    </div>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="container">
                    <div className="copyright">
                        <div className="copyright-text">
                            <p className="mb-0">{footerDiv1Div0Div0Div0P0PText}</p>
                        </div>
                        <div className="copyright-menu">
                            <div className="copy-img">
                                {renderCollectionNode(
                                    footerSectionDivs,
                                    (item: FooterSectionDivsItem) => (
                                        renderItemNode(footerSectionDivsLinkVisible, footerSectionDivsLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} {...(typeof footerSectionDivsLinkProps === "function" ? footerSectionDivsLinkProps(item) : (footerSectionDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                                {renderItemNode(footerSectionDivsImageVisible, footerSectionDivsImageRenderer, item, (
                                                    <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.className ?? "img-fluid pay-1"} {...(typeof footerSectionDivsImageProps === "function" ? footerSectionDivsImageProps(item) : (footerSectionDivsImageProps ?? {}))} {...(typeof linkImageWithBasePath0ImageProps === "function" ? linkImageWithBasePath0ImageProps(item) : (linkImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </SmartLink>
                                        ))
                                    ),
                                    footerSectionDivsItemWrapper,
                                    footerSectionDivsRenderer
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {renderNode(footerDiv1Link0LinkVisible, footerDiv1Link0LinkRenderer, (
                    <SmartLink href={footerDiv1Link0LinkHref} className="back-to-top" onClick={scrollToTop} {...(footerDiv1Link0LinkProps ?? {})}>
                        <i className="isax isax-arrow-up-2" />
                        {" "}
                    </SmartLink>
                ))}
            </div>
            {renderNode(footerImageWithBasePath0ImageVisible, footerImageWithBasePath0ImageRenderer, (
                <SmartImage src={footerImageWithBasePath0ImageSrc} alt={footerImageWithBasePath0ImageAlt} className="img-fluid footer-shadow-img" {...(footerImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(footerImageWithBasePath1ImageVisible, footerImageWithBasePath1ImageRenderer, (
                <SmartImage src={footerImageWithBasePath1ImageSrc} alt={footerImageWithBasePath1ImageAlt} className="img-fluid footer-lab-img" {...(footerImageWithBasePath1ImageProps ?? {})} />
            ))}
        </footer>
    );
};

export default HomeTwelveFooterSectionGenerated;
